import { PseudoElementSelector } from "./pseudo-element.js";
/**
 * {@link https://drafts.csswg.org/css-pseudo-4/#first-letter-pseudo}
 */
export class FirstLetter extends PseudoElementSelector {
    static of() {
        return new FirstLetter();
    }
    constructor() {
        super("first-letter");
    }
    *[Symbol.iterator]() {
        yield this;
    }
}
(function (FirstLetter) {
    FirstLetter.parse = PseudoElementSelector.parseLegacy("first-letter", FirstLetter.of);
})(FirstLetter || (FirstLetter = {}));
//# sourceMappingURL=first-letter.js.map